<template>
    <div class="content-body">
        <div class="left-list">
            <div class="left-list-title">
                <div class="color-block"></div>
                <div class="title">首页栏</div>
                <div class="color-block end"></div>
            </div>
            <div class="left-list-content">
                <div class="block"></div>
                <div class="left-list-splitter"></div>
                <div class="left-list-content">
                    <div class="content">
                        <p>
                            1、环境污染加剧
                        </p>
                        <p>
                            2、森林锐减和物种灭绝
                        </p>
                        <p>
                            3、淡水资源短缺
                        </p>
                    </div>
                    <div class="content">
                        <div class="split-style">
                            <span class="split-style-span"></span>
                            <span class="split-style-span"></span>
                            <span class="split-style-span"></span>
                        </div>
                        <p>保护环境诗</p>
                        <p>垃圾不可随丢</p>
                        <p>废物不可随排</p>
                        <p>绿化不可乱坏</p>
                        <p>水电资源要珍惜</p>
                        <p>废物利用要得</p>
                        <p>花草树木多植</p>
                        <p>携手共建好园</p>
                        <p>保护环境起起</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-content">
            <div class="right-content-title"></div>
            <div class="right-content-body">
                <div class="title">
                    <img src="../assets/artist-text/earth-now.png" height="50px">
                </div>
                <div class="content">
                    <p class="indent">人口爆炸和人类活动以直接或间接的形式，从多方面破坏了地球的生态系统，许多种生物已濒临灭绝。物种分布改变以及具体物种的灭绝对人类的影响究竟如何，虽然还不十分清楚，但作为一种标志，它表明地球作为人类生命活动的场所，其可居住性正面临着越来越严重的问题。 </p>
                    <p class="bold">1、环境污染加剧</p>
                    <p class="indent">全球每年排放进入大气层的气体，CO2为57亿t，CH4约2亿t。排放有害金属铝200万t，砷7.8万t，汞1.1万t、镉5500t，超出自然背景值的20~300倍。SO2的排放，诱发的酸雨的频度在增加，面积在扩大；空气质量严重下降，全球有8亿人生活在空气污染的城市中；江河湖海的污染日趋严重，淡水匮乏使12亿人口生活在缺水城市，14亿人口在没有废水处理设施下生活；水质污染引发的疾病死亡率已成为人体健康最主要的危害；城市垃圾、污水、船舶废物、石油和工业污染、放射性废物等大量涌入海洋，每年有200亿t污染物从河流进入海洋，约500万t垃圾被抛进海洋，在入海口处数万平方公里的臭氧层正在扩大。 </p>
                    <p class="bold">2、森林锐减和物种灭绝</p>
                    <p class="indent">生物多样性的世界正发生着严重的危机。研究表明（IIED，1987），在人类活动干扰以前，全世界约有森林和林地60亿hm2。到1954年世界森林和林地面积减少到40亿hm2，其中温带森林减少了32％～33％，热带森林减少了15％～20％。近30年来，世界森林，特别是热带森林的减少速度明显加快，平均每年减少800万hm2。中美洲由1950年的1.15亿hm2减到1983年中0.71亿hm2。非洲森林减少更快，从1950年的9.01亿hm2减至1983年的6.9亿hm2。 </p>
                    <p class="bold">3、淡水资源短缺</p>
                    <p class="indent">据IIED提供的资料1987年，全球约140亿m3的水量中，大约有4.2亿m3淡水，约占全球水量的3％，其中约77.2％被冷储在冰盖和冰川中，22.4％是地下水和土壤水，约0.4％为湖泊、沼泽和河水。 </p>
                    <p class="indent">由于水循环的结果，全球水量分布极不均匀。从作物需水量的角度出发，非洲中东和中亚大部分地区，美国西部，墨西哥西北部，智利和阿根廷的部分地区以及澳大利亚全部都是贫水区，其年蒸发量超过年降雨量。另一方面，20世纪以来，世界用水量大幅度增加，年用水量从1990年的约4000亿m3增加到1995年的3万亿m3，增长了6.5倍。到2000年，全球淡水用量已达6万亿m3。目前，世界上已有43个国家和地区缺水，占全球陆地面积的60％，约20亿人用水紧张，10亿人得不到良好的饮用水。</p>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IndexView"
    }
</script>

<style lang="scss" scoped>
    .content-body {
        background: #c7f8d9;
        padding-top: 12px;
        height: 665px;
    }
    .left-list {
        width: 130px;
        height: 100%;
        float: left;
        .left-list-title {
            height: 18px;
            background: linear-gradient(#fff, #EAEAEA);
            padding: 5px;
            font-size: 14px;

            &>div {
                float: left;
            }
            .title {
                margin-left: 5px;

            }
            .end {
                float: right;
                margin-right: 5px;
                width: 2px;
            }
        }
    }
    .color-block {
        background-image: linear-gradient(#8690A0, #8690A0 0%,#8690A0 50%, #4A4C4D 50%, #4A4C4D 100%);
        width: 2px;
        height: 7px;
        padding-top: 10%;
    }
    .left-list-content {
        background: #8DC1F2;
        height: 560px;
        text-align: center;
        font-size: 13px;
        .block {
            height: 5px;
        }
        .content {
            margin-top: 35px;
            width: 72%;
            margin-left: 9%;
        }
    }
    .left-list-splitter {
        border-top: 1px dotted #9BC7EE;
        border-bottom: 1px dotted #9BC7EE;
        height: 35px;
    }
    .split-style {
        text-align: center;
        .split-style-span1 {
            width: 10px;
            height: 2px;
            margin-left: 5px;
            display: inline-block;
            background: #000;
        }
        .split-style-span {
            width: 15px;
            height: 4px;
            margin-left: 5px;
            display: inline-block;
            background: #000;
            box-shadow: 5px 6px #5A656E;
        }
    }
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .bold {
            font-weight: bolder;
        }
        .indent {
            text-indent: 26px;
        }
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            -ms-overflow-style: none;
            overflow: -moz-scrollbars-none;

            &::-webkit-scrollbar {
                width: 0 !important
            }
        }
        .title {
            text-align: center;
        }
    }
</style>